export { default } from './PriceInput';
